/**
 * The Manage tab's sub-views (plan section 13 tab 7), in SegmentedTabs order.
 * ManageTab renders the entry whose path is the first URL segment after
 * /lms/manage (the first entry when there is none).
 *
 * Hot file (plan 15.12): WP-03 only. A sub-view WP replaces the ONE file its
 * entry imports (keeping that file's default export); it never edits this
 * registry, ManageTab.tsx or tabs/config.ts.
 */
import { ClipboardList, Library, Megaphone, Send, Settings, UsersRound } from 'lucide-react';
import type { LmsSubview } from '../config';
import CatalogView from './catalog/CatalogView';
import GroupsView from './groups/GroupsView';
import AssignView from './assign/AssignView';
import CampaignsView from './campaigns/CampaignsView';
import OnboardingTemplatesView from './onboardingTemplates/OnboardingTemplatesView';
import SettingsView from './settings/SettingsView';

// Descriptions are double-quoted on purpose (the apostrophe hazard, common.md).
export const MANAGE_SUBVIEWS: LmsSubview[] = [
  {
    path: 'catalog',
    label: 'Catalog',
    // plan 8.1, R10, R11 (scenarios included, R8)
    description: "Courses and best-practice scenarios: edit drafts, publish new versions and compare versions.",
    icon: Library,
    Component: CatalogView,
    ownerWp: 'WP-44',
  },
  {
    path: 'groups',
    label: 'Groups',
    // plan 8.2, R6, R19
    description: "Saved groups and requirement profiles, their members, and the courses each profile requires.",
    icon: UsersRound,
    Component: GroupsView,
    ownerWp: 'WP-43',
  },
  {
    path: 'assign',
    label: 'Assign',
    // plan 8.2 (the Assign wizard), R6, R8
    description: "Send a course to people chosen by site, role, group, profile or name, with a due window.",
    icon: Send,
    Component: AssignView,
    ownerWp: 'WP-43',
  },
  {
    path: 'campaigns',
    label: 'Campaigns',
    // plan section 13 tab 7
    description: "The history of every send: who received it and where each person stands.",
    icon: Megaphone,
    Component: CampaignsView,
    ownerWp: 'WP-43',
  },
  {
    path: 'onboarding-templates',
    label: 'Onboarding templates',
    // plan 12.1, R14
    description: "The onboarding checklists: their items, who does each one, the evidence it needs and when it is due.",
    icon: ClipboardList,
    Component: OnboardingTemplatesView,
    ownerWp: 'WP-47',
  },
  {
    path: 'settings',
    label: 'Settings',
    // plan 5.8, 4.10
    description: "Reminder timing, the weekly digest, certificate details, the built-in catalog install, and whether email is switched on.",
    icon: Settings,
    Component: SettingsView,
    ownerWp: 'WP-48',
  },
];
